var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * EmailReplyAll component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconEmailReplyAll extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon cat-c-icon-bi-directional', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.5297 15.6519C12.8226 15.359 12.8226 14.8841 12.5297 14.5913C12.2368 14.2984 11.7619 14.2984 11.469 14.5913L9.12787 16.9324C8.83498 17.2253 8.83498 17.7002 9.12787 17.9931L11.469 20.3342C11.7619 20.6271 12.2368 20.6271 12.5297 20.3342C12.8226 20.0413 12.8226 19.5665 12.5297 19.2736L10.7189 17.4627L12.5297 15.6519ZM17.2121 14.5913C17.505 14.8841 17.505 15.359 17.2121 15.6519L16.1513 16.7126H19.0229C20.0497 16.7126 21.0344 17.1205 21.7605 17.8466C22.4865 18.5726 22.8944 19.5574 22.8944 20.5842V22.145C22.8944 22.5592 22.5586 22.895 22.1444 22.895C21.7302 22.895 21.3944 22.5592 21.3944 22.145V20.5842C21.3944 19.9552 21.1446 19.352 20.6998 18.9073C20.2551 18.4625 19.6519 18.2126 19.0229 18.2126H16.1511L17.2121 19.2736C17.505 19.5665 17.505 20.0413 17.2121 20.3342C16.9192 20.6271 16.4443 20.6271 16.1514 20.3342L13.8102 17.9931C13.7286 17.9114 13.6697 17.8156 13.6336 17.7135C13.6057 17.6351 13.5906 17.5506 13.5906 17.4626C13.5906 17.2955 13.6452 17.1412 13.7376 17.0165C13.7617 16.9841 13.7883 16.9536 13.8172 16.9255L16.1514 14.5913C16.4443 14.2984 16.9192 14.2984 17.2121 14.5913Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.84196 2.84245C2.99401 2.6904 3.20023 2.60498 3.41526 2.60498H19.023C19.238 2.60498 19.4442 2.6904 19.5963 2.84245C19.7483 2.9945 19.8337 3.20072 19.8337 3.41575V3.43327L11.2192 9.52089L2.60449 3.43318V3.41575C2.60449 3.20072 2.68991 2.9945 2.84196 2.84245ZM1.10449 3.82101V14.3411C1.10449 14.954 1.34795 15.5417 1.7813 15.9751C2.21465 16.4084 2.80241 16.6519 3.41526 16.6519H5.75641C6.17063 16.6519 6.50641 16.3161 6.50641 15.9019C6.50641 15.4877 6.17063 15.1519 5.75641 15.1519H3.41526C3.20023 15.1519 2.99401 15.0665 2.84196 14.9144C2.68991 14.7624 2.60449 14.5562 2.60449 14.3411V5.26992L10.7863 11.0518C11.0458 11.2351 11.3926 11.2351 11.652 11.0518L19.8337 5.27001V12.7804C19.8337 13.1946 20.1695 13.5304 20.5837 13.5304C20.9979 13.5304 21.3337 13.1946 21.3337 12.7804V3.83453C21.3339 3.82548 21.3339 3.81643 21.3337 3.80737V3.41575C21.3337 2.8029 21.0903 2.21514 20.6569 1.78179C20.2236 1.34844 19.6358 1.10498 19.023 1.10498H3.41526C2.80241 1.10498 2.21465 1.34844 1.7813 1.78179C1.34795 2.21514 1.10449 2.8029 1.10449 3.41575V3.82088C1.10449 3.82093 1.10449 3.82097 1.10449 3.82101Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconEmailReplyAll.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconEmailReplyAll.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconEmailReplyAll.prototype, "size", void 0);
if (customElements.get('cat-icon-email-reply-all') === undefined) {
    customElements.define('cat-icon-email-reply-all', BlocksIconEmailReplyAll);
}
